<template>
  <div>
    <v-row>
      <v-col class="text-center">
        <v-icon
          color="secondary"
          large
        >
          error
        </v-icon>
      </v-col>
    </v-row>
    <v-row
      no-gutters
      class="text-center"
    >
      <v-col
        cols="12"
        class="title"
      >
        {{ title || 'Connection Error' }}
      </v-col>
      <v-col cols="12">
        <div class="errorMsg">
          {{ msg }}
        </div>
      </v-col>
    </v-row>
    <v-row class="text-center mt-3">
      <v-col>
        <v-btn
          to="/"
          rounded
          dark
          color="secondary"
        >
          Back to home
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ErrorConnection extends Vue {
  @Prop() msg?: string
  @Prop() title?: string
}
</script>

<style lang="scss" scoped>
.errorMsg {
  color: grey;
}
</style>
